export enum TableType {
  Address = 'ADDRESS',
  Cluster = 'CLUSTER',
  Transaction = 'TRANSACTION',
  TransactionDetail = 'TRANSACTION_DETAIL',
  UUID = 'uuid',
  Annotation = 'Annotation',
  AnnotationLink = 'AnnotationLink',
}
